import React, { ReactNode, CSSProperties } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setVisiblePopUp } from 'store/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import style from './style.module.scss';
import { AppDispatch, RootState } from '../../store/store';

interface PopupProps {
  width?: string | number;
  children?: ReactNode;
}

const Popup: React.FC<PopupProps> = ({ width, children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const visiblePopUp = useSelector((state: RootState) => state.ui.visiblePopUp);

  const popupStyle: CSSProperties = width ? { width } : {};

  const handleClose = () => {
    dispatch(setVisiblePopUp(false));
  };

  return (
    <>
      {visiblePopUp && (
        <div className={style.outer_pop}>
          <div className={style.inner_pop} style={popupStyle}>
            <IconButton
              className={style.close_button}
              onClick={handleClose}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
            {children}
          </div>
          <div className={style.bg_pop} onClick={handleClose} />
        </div>
      )}
    </>
  );
};

export default Popup;
